import { cva } from "class-variance-authority";

export const variants = {
  primary: `data-[disabled=false]:border-[1px] data-[disabled=false]:border-border-primary-button
      data-[destructive=true]:data-[disabled=false]:border-[0.5px]
      bg-buttons-cta-primary text-on-primary
      data-[disabled=false]:hover:bg-surface-primary-hover
      data-[disabled=false]:active:bg-surface-primary-pressed
      disabled:bg-buttons-cta-primary-disabled disabled:text-disabled
      data-[destructive=true]:data-[disabled=false]:bg-buttons-cta-primary-destructive
      data-[destructive=true]:data-[disabled=false]:border-border-destructive-button
      data-[destructive=true]:data-[disabled=false]:hover:bg-buttons-cta-primary-destructive-hover
      data-[destructive=true]:data-[disabled=false]:active:bg-buttons-cta-primary-destructive-pressed`,
  secondary: `border-border-secondary-button bg-buttons-cta-secondary text-primary
      data-[disabled=false]:hover:bg-buttons-cta-secondary-hover
      data-[disabled=false]:active:bg-surface-pressed
      disabled:border-border-disabled-button disabled:bg-surface-disabled disabled:text-disabled
      data-[destructive=true]:data-[disabled=false]:border-border-destructive-button
      data-[destructive=true]:data-[disabled=false]:bg-buttons-cta-secondary
      data-[destructive=true]:data-[disabled=false]:text-negative
      data-[destructive=true]:data-[disabled=false]:hover:bg-surface-destructive-hover
      data-[destructive=true]:data-[disabled=false]:active:bg-surface-destructive-pressed`,
  secondaryNoBg: `border-border-secondary-button bg-transparent text-primary
      data-[disabled=false]:hover:bg-surface-hover-strong
      data-[disabled=false]:active:bg-surface-pressed
      data-[selected=true]:border-border-selected-button
      data-[selected=true]:bg-surface-focus-selected
      disabled:border-border-disabled-button disabled:text-disabled
      data-[destructive=true]:data-[disabled=false]:border-border-destructive-button
      data-[destructive=true]:data-[disabled=false]:text-negative
      data-[destructive=true]:data-[disabled=false]:hover:bg-surface-destructive-hover
      data-[destructive=true]:data-[disabled=false]:active:bg-surface-destructive-pressed
      shadow-none`,
  tertiary: `bg-transparent text-cta font-normal gap-0
      data-[size=lg]:px-2
      data-[size=default]:p-1
      data-[disabled=false]:hover:bg-surface-hover-strong
      data-[disabled=false]:active:bg-surface-pressed
      disabled:text-disabled
      data-[destructive=true]:data-[disabled=false]:text-negative
      data-[destructive=true]:data-[disabled=false]:hover:bg-surface-destructive-hover
      data-[destructive=true]:data-[disabled=false]:active:bg-surface-destructive-pressed
      shadow-none`,
  icon: `border-border-secondary-button bg-buttons-cta-secondary
      data-[disabled=false]:hover:bg-buttons-cta-secondary-hover-soft
      data-[disabled=false]:active:bg-buttons-cta-secondary-hover-strong
      data-[selected=true]:border-border-selected-button
      data-[selected=true]:bg-buttons-cta-secondary-hover-soft
      disabled:bg-surface-disabled
      data-[destructive=true]:data-[disabled=false]:border-border-destructive-button
      data-[destructive=true]:data-[disabled=false]:hover:bg-surface-destructive-hover
      data-[destructive=true]:data-[disabled=false]:active:bg-surface-destructive-pressed`,
  iconWShadow: `border-border-icon-with-shadow-button bg-buttons-icon-with-shadow p-1
      shadow-[0_2px_8px_-2px_var(--black-16)]
      data-[disabled=false]:hover:bg-buttons-cta-secondary-hover-soft
      data-[disabled=false]:active:bg-buttons-cta-secondary-hover-strong
      data-[selected=true]:border-border-selected-button
      data-[selected=true]:bg-buttons-cta-secondary-hover-soft
      disabled:bg-surface-disabled
      data-[destructive=true]:data-[disabled=false]:border-border-destructive-button
      data-[destructive=true]:data-[disabled=false]:hover:bg-surface-destructive-hover
      data-[destructive=true]:data-[disabled=false]:active:bg-surface-destructive-pressed`,
  iconNoBg: `bg-transparent
      data-[disabled=false]:hover:bg-surface-hover-strong
      data-[disabled=false]:active:bg-surface-pressed
      data-[selected=true]:border-border-selected-button
      data-[selected=true]:bg-surface-focus-selected
      data-[destructive=true]:data-[disabled=false]:hover:bg-surface-destructive-hover
      data-[destructive=true]:data-[disabled=false]:active:bg-surface-destructive-pressed
      shadow-none`,
  link: "font-normal text-link hover:text-link-hover",
  filter: `bg-transparent text-text-body-secondary border-transparent
      hover:bg-surface-hover-soft
      data-[selected=true]:bg-badges-selected
      data-[selected=true]:text-text-body-primary
      data-[selected=true]:border-border-badge-selected
      text-sm font-medium h-8 min-w-8 px-2 py-1.5 rounded-lg whitespace-nowrap`
};

export const buttonVariants = cva(
  "border-[0.5px] border-transparent inline-flex gap-1 items-center justify-center whitespace-nowrap rounded-lg text-base font-semibold transition-all duration-200 ease-in-out shadow-lg disabled:pointer-events-none disabled:shadow-none outline-none select-none",
  {
    variants: {
      variant: variants,
      size: {
        default: "h-8 px-2",
        lg: "h-9 px-[10px]",
        icon: "shrink-0"
      }
    },
    // After the size classes, so links drop the size's padding.
    compoundVariants: [{ variant: "link", className: "p-0" }],
    defaultVariants: {
      variant: "primary",
      size: "default"
    }
  }
);
